import contryList from 'world-countries/dist/countries.json';

export const countryOptions = contryList
	.map(item => ({
		value: item.cca2.toLowerCase(),
		label: item.name.common,
	}))
	.sort((a, b) => (a.label > b.label ? 1 : -1));

export const mapCountryCode = code => {
	const result = countryOptions.filter(item => item.value === code);

	return result.length > 0 ? result[0].label : '';
};



// WEBPACK FOOTER //
// ./src/util/country/util.js